import {ApiUrl} from "../../../auth/authMethods";
import {useState} from "react";
import axios from "axios";
import LoadingButton from "@mui/lab/LoadingButton";
import ReceiptIcon from "@mui/icons-material/Receipt";

export default function DownloadToAproveReport({filter}) {

    const url = ApiUrl + '/pagamentos/to-aprove/report'

    const [loading, setLoading] = useState(false)

    function formatDateToday() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Os meses são base 0 (janeiro = 0)
        const year = today.getFullYear();

        return `${day}-${month}-${year}`;
    }

    const handleClick = () => {
        setLoading(true)

        const queryParams = new URLSearchParams(filter).toString();

        console.log(`${url}?${queryParams}`)

        const axiosConfig = {
            method: 'get',
            url: `${url}?${queryParams}`,
            responseType: 'blob'
        };

        // Realiza a requisição Axios
        axios(axiosConfig)
            .then(response => {
                // Cria um objeto URL para o blob
                const blobUrl = URL.createObjectURL(response.data);

                // Cria um link para download
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = 'relatorio-aprovacoes-' + formatDateToday() + '.xlsx';

                // Adiciona o link ao corpo do documento
                document.body.appendChild(link);

                // Simula um clique no link para iniciar o download
                link.click();

                // Remove o link do corpo do documento após o download
                document.body.removeChild(link);
            })
            .catch(error => console.error('Erro ao gerar relatório:', error))
            .finally(() => {
                setLoading(false)
            })
    }


    return <span style={{cursor: "pointer"}}>
        <LoadingButton
            onClick={handleClick}
            loading={loading}
            loadingPosition="start"
            startIcon={<ReceiptIcon/>}
            variant="contained"
            className='button-show'
        >
            <span>
                &nbsp;Baixar relatório
            </span>
        </LoadingButton>
    </span>
}